import { ShoppingBag, Plus, Minus, ChevronRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function CartPanel({ cart, cartTotal, updateQty, formatPrice, onCheckout, step }) {
  return (
    <div className="bg-white rounded-2xl border border-garden-800/5 shadow-sm overflow-hidden" data-testid="cart-panel">
      <div className="bg-garden-800 text-white px-5 py-4">
        <h3 className="font-heading font-semibold text-lg flex items-center gap-2">
          <ShoppingBag size={18} /> Votre commande
        </h3>
      </div>
      <div className="p-5">
        {cart.length === 0 ? (
          <p className="text-sm text-charcoal/50 text-center py-6">Votre panier est vide</p>
        ) : (
          <div className="space-y-3 max-h-[400px] overflow-y-auto">
            {cart.map((item) => (
              <div key={item.key} className="flex items-center gap-3 py-2 border-b border-garden-100 last:border-0" data-testid={`cart-item-${item.key}`}>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-charcoal truncate">{item.name}</p>
                  {item.variant_name && (
                    <span className="text-xs text-charcoal/50">{item.variant_name}</span>
                  )}
                  <p className="text-xs text-garden-600">{formatPrice(item.price)}</p>
                </div>
                <div className="flex items-center gap-1">
                  <button
                    onClick={() => updateQty(item.key, -1)}
                    className="w-7 h-7 rounded-full bg-garden-100 flex items-center justify-center text-garden-800 hover:bg-garden-200"
                    data-testid={`cart-minus-${item.key}`}
                  >
                    <Minus size={12} />
                  </button>
                  <span className="w-6 text-center text-sm font-medium">{item.quantity}</span>
                  <button
                    onClick={() => updateQty(item.key, 1)}
                    className="w-7 h-7 rounded-full bg-garden-100 flex items-center justify-center text-garden-800 hover:bg-garden-200"
                    data-testid={`cart-plus-${item.key}`}
                  >
                    <Plus size={12} />
                  </button>
                </div>
                <span className="text-sm font-medium text-garden-800 w-14 text-right">
                  {formatPrice(item.price * item.quantity)}
                </span>
              </div>
            ))}
          </div>
        )}
        {cart.length > 0 && (
          <>
            <div className="border-t border-garden-200 mt-4 pt-4 flex justify-between items-center">
              <span className="font-heading font-semibold text-lg text-garden-800">Total</span>
              <span className="font-heading font-bold text-2xl text-garden-800">{formatPrice(cartTotal)}</span>
            </div>
            {step === 'menu' && (
              <Button
                onClick={onCheckout}
                data-testid="cart-checkout-btn"
                className="w-full bg-sunny text-charcoal hover:bg-yellow-300 rounded-full py-5 mt-4 text-base font-semibold shadow-md hover:scale-[1.02] transition-all"
              >
                Choisir le créneau <ChevronRight size={18} className="ml-1" />
              </Button>
            )}
          </>
        )}
      </div>
    </div>
  );
}
